import { post, get, patch, deleteRequest } from "./restApi";

export const createMachineCancellationRequest = (payload) => {
  return post("machine-cancellation-request/create", { ...payload });
};
export const getMachineCancellationRequests = (payload) => {
  return patch("machine-cancellation-request/get-list", { ...payload });
};
export const getMachineCancellationRequestById = (id) => {
  return patch(`machine-cancellation-request/get-by-id/${id}`);
};
export const updateMachineCancellationRequestById = (id, payload) => {
  return patch(`machine-cancellation-request/update-by-id/${id}`, {
    ...payload,
  });
};
export const deleteMachineCancellationRequest = (payload) => {
  return deleteRequest(`machine-cancellation-request/delete-by-id`, {
    ...payload,
  });
};
export const exportTheMachineShutdownRequestFileWord = (id, payload) => {
  return get(`machine-cancellation-request/export-file-word/${id}`, {
    ...payload,
  });
};
export const approveMachineCancellationRequest = (id, payload) => {
  return post(`machine-cancellation-request/approve/${id}`, { ...payload });
};
export const confirmTheMachineDisposalRequestNew = (id, payload) => {
  return post(`machine-cancellation-request/confirm-new/${id}`, { ...payload });
};
export const approveTheMachineDisposalRequestAssetMaintenance = (
  id,
  payload,
) => {
  return post(
    `machine-cancellation-request/approve-machine-disposal-request-asset-maintenance/${id}`,
    { ...payload },
  );
};
export const rejectTheMachineDisposalRequestAssetMaintenance = (
  id,
  payload,
) => {
  return post(
    `machine-cancellation-request/reject-machine-disposal-request-asset-maintenance/${id}`,
    { ...payload },
  );
};
export const createMachineCancellationRequestAttachment = (payload) => {
  return post(
    `machine-cancellation-request/create-machine-cancellation-request-attachment`,
    { ...payload },
  );
};
export const deleteMachineCancellationRequestAttachment = (payload) => {
  return deleteRequest(
    `machine-cancellation-request/delete-machine-cancellation-request-attachment`,
    { ...payload },
  );
};
export const getMachineCancellationRequestAttachmentByMachineCancellationRequestId =
  (id, payload) => {
    return get(
      `machine-cancellation-request/get-machine-cancellation-request-attachment-by-machine-cancellation-request-id/${id}`,
      { ...payload },
    );
  };
